import axios from "axios";

// Fallback to same-origin when REACT_APP_BACKEND_URL is not set at build time.
// In production behind nginx, /api/* is proxied to the FastAPI backend on the
// same host, so an empty base ("") + "/api" produces valid relative URLs.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

const TOKEN_KEY = "ph_admin_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    // ignore
  }
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Guard against nginx SPA fallback: if we asked for JSON but got HTML back,
    // treat as a network error so calling code hits the .catch branch rather
    // than passing an HTML string into array/object consumers.
    const ct = String(r.headers?.["content-type"] || "").toLowerCase();
    if (typeof r.data === "string" && ct.includes("text/html")) {
      return Promise.reject(new Error("API returned HTML — backend unreachable or /api proxy misconfigured"));
    }
    return r;
  },
  (error) => {
    if (error?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        setToken(null);
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);
